import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const UCCOFOR_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/uccofor/logo.png",
        alt: "Urban Counseling Collective Logo",
        style: { width: "300px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 43,
  state: "OR",
  departmentIds: [264, 273, 529],
};
